
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2714_41938)","fill":"#fff"}},[_c('path',{attrs:{"d":"M19.667 16.903H1.335a.836.836 0 01-.833-.833V4.405c0-.459.375-.834.833-.834h18.332c.458 0 .833.375.833.834V16.07a.836.836 0 01-.833.833zM2.168 15.237h16.665v-10H2.168v10z"}}),_c('path',{attrs:{"d":"M10.477 12.52a1.68 1.68 0 01-.975-.316l-7.85-6.316a.835.835 0 111.05-1.3l7.817 6.29 7.807-6.29a.836.836 0 011.175.133.843.843 0 01-.133 1.175l-7.833 6.266c-.3.242-.675.367-1.041.367l-.017-.009z"}}),_c('path',{attrs:{"d":"M1.335 16.903a.83.83 0 01-.592-1.416l5.833-5.833a.83.83 0 111.175 1.175L1.92 16.66a.818.818 0 01-.592.242h.008zM19.666 16.903a.854.854 0 01-.591-.241l-5.833-5.833a.83.83 0 111.175-1.175l5.832 5.833a.83.83 0 01-.591 1.416h.008z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2714_41938"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    